// extracted by mini-css-extract-plugin
export default {"root":"HQ0R0JWp8QnG1avV9Opt"};